import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, InputX, LayerBottom, Layer, Switch, NoData } from 'components'
import { useNavigate } from 'react-router-dom'
import Lib from 'library'
import styles from './index.module.css'
import { useRecoilState } from 'recoil'
import { influencerState } from './states'


const InfluencerProfile = () => {

	const App = useApp()
	const navigate = useNavigate()

	const [profileImg, setProfileImg] = useState(false) // 프로필 이미지 
	const [agreeLayer, setAgreeLayer] = useState(false) // 마케팅/이벤트 알림 Layer
	const [nickName, setNickName] = useState('')  // 프로필 닉네임
	const [overlapState, setOverlapState] = useState(true) // 닉네임 중복 체크
	const [emptyState, setEmptyState] = useState() // 닉네임 공백 체크
	const [prflData, setPrflData] = useState()   // 프로필 이미지 경로 정보
	const [profile, setProfile] = useState()  // 선택된 프로필 이미지 
	const [profileBasic, setProfileBasic] = useState() // 선택된 프로필 이미지 서버에 전달해주는값
	const [onSubScoff, setSubScOn] = useState() // 구독한 활동 알림
	const [onMarketingoff, setMarketingOn] = useState() // 마케팅/이벤트 알림
	const [myInfoData, setMyInfoData] = useRecoilState(influencerState) // 유저 정보
	const [dupButtonDisabled, setDupButtonDisabled] = useState(true)
	const [buttonDisabled, setButtonDisabled] = useState(true)
	const [didDupCheck, setDidDupCheck] = useState(true)

	const closeProfile = () => {
		setProfileImg(false)
	}

	const showProfile = () => {
		setProfileImg(true)
	}

	const closeAgree = () => {
		setAgreeLayer(false)
	}

	useEffect(() => {
		setDupButtonDisabled(overlapState)
		setButtonDisabled(overlapState)
	}, [overlapState])

	// 중복확인
	const overlapConfirm = (name) => {
		Lib.post(`/api/infl/chk/ncknmdup`, {
			ncknm: name
		}, data => {
			setOverlapState(data.dupCnt === "0" ? false : true)
			setEmptyState(false)
			setDidDupCheck(data.dupCnt === "0")
		})
	}

	// 닉네임 변경
	const onChange = (e) => {

		setNickName(e.target.value);
		setDidDupCheck(false)

		//닉네임 입력시 이모지값 체크
		const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
		if (regex.test(e.target.value)) {
			App.alert('이모티콘은 사용할 수 없습니다.')
			setNickName(nickName)
		}
	}

	// 닉네임 초기화
	const resetNickName = () => {
		Lib.get(`/api/infl/rncknm`, data => {
			setNickName(data.randNcknm)
			overlapConfirm(data.randNcknm)
		})
	}

	// 사용가능한 닉네임인지 확인
	const overlapText = () => {
		if (overlapState === true) {
			return (
				<div>
					<span style={{ fontWeight: 'normal', fontSize: '1.4rem', lineHeight: '2rem', color: '#FF3333', marginTop: '0.5rem' }}>이미 사용중인 닉네임입니다.</span>
				</div>
			)
		} else if (dupButtonDisabled === true && overlapState === false) {
			return (
				<div>
					<span style={{ fontWeight: 'normal', fontSize: '1.4rem', lineHeight: '2rem', color: '#FF3333', marginTop: '0.5rem' }}>최소 1자리~최대 10자리까지 가능합니다.</span>
				</div>
			)
		} else {
			return (
				<div>
					<span style={{ fontWeight: 'normal', fontSize: '1.4rem', lineHeight: '2rem', color: '#298CFA', marginTop: '0.5rem' }}>사용가능한 닉네임입니다.</span>
				</div>
			)
		}
	}

	useEffect(() => {
		const empty = /\s/g;
		if (empty.test(nickName) || nickName === '') {
			setOverlapState(false)
			setDupButtonDisabled(true)
			setButtonDisabled(true)
		} else {
			setDupButtonDisabled(false)
			setButtonDisabled(false)
		}
	}, [nickName])

	// 구독자 활동알림 on off 기능
	const onSubScToggle = () => {
		setSubScOn(!onSubScoff);
	}

	// 마케팅/이벤트 알림 on off 기능
	const onMarketingToggle = () => {
		setMarketingOn(!onMarketingoff);
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")

		// 프로필 정보
		const profileData = [
			{
				prflCd: "01",
				prflPath: '/images/profile/influencer_profile01.svg',
			},
			{
				prflCd: "02",
				prflPath: '/images/profile/influencer_profile02.svg',
			},
			{
				prflCd: "03",
				prflPath: '/images/profile/influencer_profile03.svg',
			},
			{
				prflCd: "04",
				prflPath: '/images/profile/influencer_profile04.svg',
			},
			{
				prflCd: "05",
				prflPath: '/images/profile/influencer_profile05.svg',
			}
		]
		setPrflData(profileData)

		// 유저 정보
		setSubScOn(myInfoData.actvtNticYn === "Y" ? true : false)
		setMarketingOn(myInfoData.eventNotiYn === "Y" ? true : false)
		setProfileBasic(myInfoData.prflCd);
		setNickName(myInfoData.ncknm)
	}, [])

	// 프로필 변경하기
	const onProfileChange = () => {

		if (!didDupCheck) {
			App.alert("닉네임 중복확인을 해 주세요.")
			return
		}

		overlapConfirm(nickName)
		if (overlapState === true || dupButtonDisabled === true) return
		if ((overlapState === false && dupButtonDisabled === false)) {
			const params = {
				actvtNticYn: onSubScoff === true ? "Y" : 'N',
				eventNotiYn: onMarketingoff === true ? "Y" : 'N',
				ncknm: nickName,
				prflCd: profileBasic
			}
			Lib.post(`/api/infl/upd`, params, () => {
				setMyInfoData(prev => ({ ...prev, ...params }))
				navigate("/home/influencerMy")
			})
		}
	}

	return (
		<div className="page">
			<div className="flex_1">
				<div className="shadow">
					<div className="padding pb_40">
						<h4>인플루언서가 되어<br />나의 자산을 뽐내보세요!</h4>
						<div className={`${styles["profile-area"]} mt_40`}>
							<div className={styles["user-img"]} onClick={showProfile}>
								<div className="img-box user-profile profile_80">
									<img src={"/images/profile/influencer_profile" + profileBasic + ".svg"} alt="프로필 이미지" />
								</div>
								<span className="camera-btn"><i className="icon icon_camera" /></span>
							</div>
							<div className="ml_20">
								<InputX onX={() => { setNickName('') }} type="text" value={nickName} onChange={onChange} maxlength={10} placeholder="닉네임 입력!!" id="" style={{ width: "15rem" }}></InputX>
								{overlapText()}
								<div className="mt_10">
									<Button disabled={dupButtonDisabled} className="btn btn--sm btn--line" onClick={() => overlapConfirm(nickName)}>중복확인</Button>
									<Button className="btn btn--sm btn--gray_line ml_5" onClick={resetNickName}>초기화</Button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="padding">
					<h3>알림설정</h3>
					<ul className={`${styles.alarm} mt_30`}>
						<li>
							<div>
								<p>구독자 활동 알림</p>
								<Switch offText="OFF" on={onSubScoff} onToggle={() => onSubScToggle()}>ON</Switch>
							</div>
							<span>내가 구독한 사람의 정보 변경 시 알려드려요.</span>
						</li>
						<li>
							<div>
								<p>마케팅/이벤트 알림</p>
								<Switch offText="OFF" on={onMarketingoff} onToggle={() => onMarketingToggle()}>ON</Switch>
							</div>
							<span>광고, 이벤트성 정보를 알려드려요</span>
						</li>
						<li>
							<div>
								<p>마케팅정보 수신동의</p>
								<div className="flex-align_center" onClick={() => setAgreeLayer(true)}>
									{
										myInfoData && myInfoData.eventNotiYn === "Y" ?
											<span>동의  ({myInfoData && Lib.dateFormat(myInfoData.eventNotiAgreeDe, ".")})</span>
											:
											<span>미동의  ({myInfoData && Lib.dateFormat(myInfoData.eventNotiAgreeDe, ".")})</span>
									}
									<i className="icon icon_arrow_sm right ml_10" />
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" disabled={buttonDisabled} onClick={onProfileChange}>변경하기</Button>
			</div>

			<ProfileSelect show={profileImg} closeLayer={closeProfile} prflData={prflData} setProfile={setProfile} profile={profile} setProfileBasic={setProfileBasic} />
			<AgreeLayerOpen show={agreeLayer} closeLayer={closeAgree} terms={myInfoData} setAgreeLayer={setAgreeLayer} />
		</div>
	)
}

const ProfileSelect = ({ show, closeLayer, prflData, setProfile, profile, setProfileBasic }) => {

	const [buttonDisabled, setButtonDisabled] = useState(true)

	const onChangeProfile = () => {
		setProfileBasic("0" + (profile + 1))
		closeLayer(closeLayer);
	}

	return (
		<LayerBottom title="변경하실 프로필을 선택하세요." show={show} closeLayer={closeLayer} outside={
			<div className="button-group">
				<Button className="btn btn--big btn-layer" disabled={buttonDisabled} onClick={onChangeProfile}>저장</Button>
			</div>
		}>
			<div className="profile-select">
				{prflData && (
					prflData.map((item, index) => {
						return (
							<div key={index} className={`${profile === index ? "active" : ""} img-box`} onClick={() => {
								setButtonDisabled(false)
								setProfile(index)}
							}>
								<div className="inner"><img src={item.prflPath} alt="" /></div>
							</div>
						)
					})
				)}
			</div>
		</LayerBottom>
	)
}

//마케팅 정보 수신동의 레이어 
const AgreeLayerOpen = ({ show, closeLayer, terms, setAgreeLayer }) => {
	return (
		<Layer show={show} closeLayer={closeLayer}>
			{terms ?
				<div className="page">
					<div className="flex_1 padding pt_20">
						<h3>{terms.termsNm}</h3>
						<div>
							<p className="termsParagraph" dangerouslySetInnerHTML={{__html: terms.eventNotiTerms.termsConts}}></p>
						</div>
					</div>
					<div className="flex-shrink_0 padding" onClick={() => setAgreeLayer(false)}>
						<Button className="btn btn--big" >확인</Button>
					</div>
				</div>
				:
				<NoData text="조회중입니다." />
			}
		</Layer>

	)
}


export default InfluencerProfile
